export default {
    parent: 'RegularLayout', // the layout we'll be using
    url: '/:company',
    abstract: true,
    template: '<ui-view/>',
    resolve: {
        user ($q, TokenService, AuthService) {
            const token = TokenService.token;
            if (token) {
                return AuthService.loginViaToken(token);
            }
            return $q.resolve();
        },
        releaseNotes (user, moment, ReleaseNoteResource) {
            // In case it is initial login make dummy query which returns nothing with tomorrows date
            let releasedFrom = moment().add(1, 'days').format('YYYY-MM-DD HH:mm:ss');
            if (user.penultimateLoginTime) {
                releasedFrom = moment.utc(moment.unix(user.penultimateLoginTime)).format('YYYY-MM-DD HH:mm:ss');
            }
            return ReleaseNoteResource.query({ releasedFrom, expand: 'activeI18n' }).$promise;
        },
        // inject translations (from application layout resolve) here to wait for enum translations before changing language
        languageReady (translations, TranslationService) {
            return TranslationService.changeLanguage();
        },
        // run bootstrap once languageReady is resolved to ensure translations have loaded for enums
        bootstrap ($q, languageReady, StateService, SiteService, SiteResource, user) {
            StateService.user = user;
            const deferred = $q.defer();
            const sites = SiteResource.userSites({ pageSize: 0 }).$promise;
            sites.then(userSites => {
                SiteService.sites = userSites;
                deferred.resolve();
            });
            return deferred.promise;
        }
    },
    data: {
        canAccess: (AuthService) => {
            return AuthService.isLoggedIn();
        }
    },
    controller (
        $state, $scope, $interval,
        TokenService, CompanyService, StateService,
        ModalService, MomentService, ReleaseNoteService,
        user, releaseNotes) {
        if ($state.params.company !== TokenService.getCompanySlug()) {
            $state.go('home');
            return;
        }
        if (!StateService.user.isAccountActivated) {
            ModalService.open({
                template: '<modals-account-activate class="wrapper" close="vm.close()" company-terms="vm.terms"/>',
                resolve: {
                    company (CompanyResource) {
                        return CompanyResource.terms().$promise;
                    }
                },
                controller ($uibModalInstance, company) {
                    this.terms = company.terms;
                    this.$uibModalInstance = $uibModalInstance;
                    this.close = () => this.$uibModalInstance.close();
                }
            });
        }
        else if (user.npsAskDate && (MomentService.isPassedDate(user.npsAskDate) || MomentService.isCurrentDate(user.npsAskDate))) {
            ModalService.open({
                template: '<modals-user-nps class="wrapper" uib-modal-instance="vm.$uibModalInstance" user="vm.user"/>',
                size: 'large',
                controller ($uibModalInstance) {
                    this.$uibModalInstance = $uibModalInstance;
                    this.user = user;
                }
            })
                .then(() => {
                    if (releaseNotes.length) {
                        ReleaseNoteService.showReleaseNotes(releaseNotes);
                    }
                })
                .catch(() => {
                    if (releaseNotes.length) {
                        ReleaseNoteService.showReleaseNotes(releaseNotes);
                    }
                })
            ;
        }
        else if (releaseNotes.length) {
            ReleaseNoteService.showReleaseNotes(releaseNotes);
        }

        const skin = TokenService.getCompanySkin();
        if (skin) {
            CompanyService.loadSkin(skin);
        }

        // set up token watcher that monitors token expiration
        const promise = TokenService.startTokenExpirationWatcher();
        const promise2 = TokenService.startTokenWatcher();
        $scope.$on('$destroy', () => {
            $interval.cancel(promise);
            $interval.cancel(promise2);
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/index.js